<template>
  <div> <!-- root element of the template -->
    <cm-service-popups></cm-service-popups>
    <cm-service-switcher-popup :closeButton="true"></cm-service-switcher-popup>
    <cm-change-password-popup v-if="changePasswordPopup" @close="changePasswordPopup = false" :data="changePasswordPopupData" class="z-10080"></cm-change-password-popup>
    <cm-user-reset-password :closeButton="true"></cm-user-reset-password>
  </div>
</template>

<script>
// services
import CMServicePopups from '@/popups/services/Popups.vue'
// service switch
import ServicesSwitcherPopup from '@/popups/ServicesSwitcherPopup.vue'

import CMChangePasswordPopup from './user/CMChangePasswordPopup.vue'

import CMUserResetPassword from '@/popups/user/CMUserResetPassword.vue'

export default {
  name: 'cm-popups',
  components: {
    'cm-service-popups': CMServicePopups,
    'cm-service-switcher-popup': ServicesSwitcherPopup,
    'cm-change-password-popup': CMChangePasswordPopup,
    'cm-user-reset-password': CMUserResetPassword
  },
  data () {
    return {
      changePasswordPopup: false,
      changePasswordPopupData: ''
    }
  },
  created () {
    this.$bus.$on('close-all-popups', () => {
      this.changePasswordPopup = false
    })
    this.$bus.$on('popup-change-password-data', e => {
      this.changePasswordPopupData = e
      this.changePasswordPopup = true
    })
  }
}
</script>
